import React, {
  useState,
  useEffect,
  useCallback,
  RefObject,
  useRef,
} from "react"
import Logo from "../../../images/arden-university.png"
import heroStyles from "./hero.module.css"
import InnerHTML from "dangerously-set-html-content"
import IframeResizer from "iframe-resizer-react"
import moment from "moment-timezone"

import MessageData from "./message-data"
const Hero = ({
  BackgroundImage,
  webinarTitle,
  webinarSubtitle,
  formId,
  formWebinarTime,
  formPardotProgrammeCode,
  formWebinarKey,
  formGuestName,
}) => {
  const isNull = formfield => {
    if (formfield === null) return String()
    else return formfield
  }

  const iframeResizerOptions = { checkOrigin: false }

  const PARDOT_TIME_FORMAT = moment(formWebinarTime).format("YYYY-MM-DD")

  // const [height, setHeight] = useState(500);
  // const iframeRef = React.createRef();
  // const handleResize = useCallback((iframe) => {
  //   const height = iframe.current.contentWindow;
  //   console.log(height)
  //   // if (height !== 0) {
  //   //   setHeight(height);
  //   // }
  // }, []);

  // useEffect(() => handleResize(iframeRef), [handleResize, iframeRef]);

  const iframeRef = useRef(null)
  const [messageData, setMessageData] = useState(undefined)

  const onResized = data => setMessageData(data)

  const onMessage = data => {
    setMessageData(data)
    iframeRef.current.sendMessage("Hello back from parent page")
  }

  return (
    <div
      className={`"full-width ${heroStyles.hero}`}
      style={{
        backgroundImage: `url(https://s.edology.com${BackgroundImage})`,
      }}
    >
      <div className="black-back full-width">
        <div className="page-wrapper">
          <div className={heroStyles.titlewrapper}>
            <h1 className={heroStyles.title}>{webinarTitle}</h1>
            <h3 className={heroStyles.subtitle}>{webinarSubtitle}</h3>
          </div>
          <div className={heroStyles.formwrapper}>
            <IframeResizer
              className="PardotForm"
              forwardRef={iframeRef}
              heightCalculationMethod="bodyOffset"
              src={`${formId}?Webinar_Date=${isNull(
                PARDOT_TIME_FORMAT
              )}&Webinar_Title=${isNull(webinarTitle)}&Webinar_Key=${isNull(
                formWebinarKey
              )}&Pardot_Programme_Code=${isNull(
                formPardotProgrammeCode
              )}&Webinar_Academics=${isNull(formGuestName)}`}
              type="text/html"
              frameborder="0"
              inPageLinks
              log
              autoResize
              style={{ minHeight: "100%" }}
              onMessage={onMessage}
              onResized={onResized}
              allowTransparency="true"
            ></IframeResizer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
